import { render, staticRenderFns } from "./inv_bankday.vue?vue&type=template&id=06af2acb&scoped=true&"
import script from "./inv_bankday.vue?vue&type=script&lang=js&"
export * from "./inv_bankday.vue?vue&type=script&lang=js&"
import style0 from "./inv_bankday.vue?vue&type=style&index=0&id=06af2acb&scoped=true&lang=less&"
import style1 from "./inv_bankday.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af2acb",
  null
  
)

export default component.exports